import Vue from 'vue'
import Router from 'vue-router'
import index from '@/pages/index.vue'
import productDetails from '@/pages/product/productDetails.vue'
import productType from '@/pages/product/productType.vue'
import productTypeScreen from '@/pages/product/productTypeScreen.vue'
import productList from '@/pages/product/productList.vue'
import invoiceManageList from '@/pages/userCenter/invoiceManageList.vue'
import invoiceManageSet from '@/pages/userCenter/invoiceManageSet.vue'
import invoiceManage from '@/pages/userCenter/invoiceManage.vue'
import receivingAddress from '@/pages/userCenter/receivingAddress.vue'
import afterSaleService from '@/pages/userCenter/afterSaleService.vue'
import me from '@/pages/userCenter/me.vue'
import meOrder from '@/pages/userCenter/meOrder.vue'
import meCart from '@/pages/userCenter/meCart.vue'
import meCollection from '@/pages/userCenter/meCollection.vue'
import meGallery from '@/pages/userCenter/meGallery.vue'
import meMsg from '@/pages/userCenter/meMsg.vue'
import meInquiry from '@/pages/userCenter/meInquiry.vue'
import downloadRecord from '@/pages/userCenter/downloadRecord.vue'
import updatePassword from '@/pages/userCenter/updatePassword.vue'
import updateHeaderImg from '@/pages/userCenter/updateHeaderImg.vue'
import accountSettings from '@/pages/userCenter/accountSettings.vue'
import userCnter from '@/pages/userCenter/userCnter.vue'
import about from '@/pages/about/about.vue'
import quickQuotation from '@/pages/quickQuotation/quickQuotation.vue'
import contact from '@/pages/contact/contact.vue'
import resetPassword from '@/pages/resetPassword/resetPassword.vue'
import upgradeEnterpriseUsers from '@/pages/upgradeEnterpriseUsers/upgradeEnterpriseUsers.vue'
import newsDetails from '@/pages/newsCenter/newsDetails.vue'
import newsCenter from '@/pages/newsCenter/newsCenter.vue'
import updatePasswords from '@/pages/updatePasswords/updatePasswords.vue'
import register from '@/pages/register/register.vue'
import confirmOrder from '@/pages/payment/confirmOrder.vue'
import orderPayment from '@/pages/payment/orderPayment.vue'
import offLinePay from '@/pages/payment/offLinePay.vue'
import buyNow from '@/pages/payment/buyNow.vue'
import orderDetails from '@/pages/userCenter/orderDetails.vue'
import search from '@/pages/search/search.vue'
import userServers from '@/pages/userCenter/userServers.vue'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  // linkActiveClass:'active',
  scrollBehavior (to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  },
  routes: [{
    path: '/',
    name: 'index',
    component: index
  }, {
    path: '/productDetails',
    name: 'productDetails',
    component: productDetails
  }, {
    path: '/productType',
    name: 'productType',
    component: productType
  },
  {
    path: '/productTypeScreen',
    name: 'productTypeScreen',
    component: productTypeScreen
  },
  {
    path: '/productList',
    name: 'productList',
    component: productList
  },
  {
    path: '/invoiceManageSet',
    name: 'invoiceManageSet',
    component: invoiceManageSet
  }, {
    path: '/invoiceManage',
    name: 'invoiceManage',
    component: invoiceManage
  }, {
    path: '/me',
    name: 'me',
    component: me,
    redirect: '/meOrder',
    children: [{
      path: '/meOrder',
      name: 'meOrder',
      component: meOrder
    }, {
      path: '/meCart',
      name: 'meCart',
      component: meCart
    }, {
      path: '/meCollection',
      name: 'meCollection',
      component: meCollection
    }, {
      path: '/meGallery',
      name: 'meGallery',
      component: meGallery
    }, {
      path: '/meMsg',
      name: 'meMsg',
      component: meMsg
    }, {
      path: '/meInquiry',
      name: 'meInquiry',
      component: meInquiry
    }, {
      path: '/updatePassword',
      name: 'updatePassword',
      component: updatePassword
    }, {
      path: '/downloadRecord',
      name: 'downloadRecord',
      component: downloadRecord
    }, {
      path: '/invoiceManageList',
      name: 'invoiceManageList',
      component: invoiceManageList
    }, {
      path: '/afterSaleService',
      name: 'afterSaleService',
      component: afterSaleService
    }, {
      path: '/receivingAddress',
      name: 'receivingAddress',
      component: receivingAddress
    }, {
      path: '/accountSettings',
      name: 'accountSettings',
      component: accountSettings
    }]
  },

  {
    path: '/updateHeaderImg',
    name: 'updateHeaderImg',
    component: updateHeaderImg
  },

  {
    path: '/userCnter',
    name: 'userCnter',
    component: userCnter
  },
  {
    path: '/about',
    name: 'about',
    component: about
  },
  {
    path: '/quickQuotation',
    name: 'quickQuotation',
    component: quickQuotation
  },
  {
    path: '/contact',
    name: 'contact',
    component: contact
  },
  {
    path: '/resetPassword',
    name: 'resetPassword',
    component: resetPassword
  },
  {
    path: '/upgradeEnterpriseUsers',
    name: 'upgradeEnterpriseUsers',
    component: upgradeEnterpriseUsers
  },
  {
    path: '/newsDetails',
    name: 'newsDetails',
    component: newsDetails
  },
  {
    path: '/newsCenter',
    name: 'newsCenter',
    component: newsCenter
  },
  {
    path: '/updatePasswords',
    name: 'updatePasswords',
    component: updatePasswords
  },
  {
    path: '/register',
    name: 'register',
    component: register
  },
  {
    path: '/confirmOrder',
    name: 'confirmOrder',
    component: confirmOrder
  },
  {
    path: '/orderPayment',
    name: 'orderPayment',
    component: orderPayment
  },
  {
    path: '/buyNow',
    name: 'buyNow',
    component: buyNow
  },
  {
    path: '/orderDetails',
    name: 'orderDetails',
    component: orderDetails
  },
  {
    path: '/search',
    name: 'search',
    component: search
  },
  {
    path: '/offLinePay',
    name: 'offLinePay',
    component: offLinePay
  },
  {
    path: '/userServers',
    name: 'userServers',
    component: userServers
  },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js